import React from 'react';
import {
    Grid,
} from '@material-ui/core';

import Calendar from '../../calendar/.mixins';

//css
import Styles from './styles';
const useStyles = Styles();

export default ({
    dtInitial,
    dtEnd,
    handlerChangeDateInitial,
    handlerChangeDateEnd
}) => {
    const classes = useStyles();
    
    return (
        <>
            <Grid
                container
                spacing={2}
            >
                <Grid item xs={6}>
                    <Calendar
                        inputLabel={"Data Início"}
                        popupLabel={"SUGESTÃO DE NOVA DATA DE ENTREGA"}
                        value={dtInitial}
                        handlerChangeDate={handlerChangeDateInitial}
                        maxDate={dtEnd}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Calendar
                        inputLabel={"Data Fim"}
                        popupLabel={"SUGESTÃO DE NOVA DATA DE ENTREGA"}
                        value={dtEnd}
                        handlerChangeDate={handlerChangeDateEnd}
                        minDate={dtInitial}
                    />
                </Grid>
            </Grid>
        </>
    );
};
